import { getItemLocation, sendGA4Event } from '@utils/analytics';
import { EventProperty, EventType } from '@utils/analytics/types';

const sendSignupGA4Event = (event: EventType, props: EventProperty): void => {
  const specificItemLocation = props?.item_location;
  const itemLocation = specificItemLocation
    ? getItemLocation(specificItemLocation)
    : getItemLocation();

  return sendGA4Event(event, {
    ...props,
    item_location: itemLocation,
  });
};

export default sendSignupGA4Event;
